import { useEffect, useState } from 'react';
import Button, { PrimaryButton } from '../../../../../Button/src/tsx/Button';
import { useBookingContext } from '../../contexts/BookingContext';
import { formatFullDate } from '../../utils/dates';
import Heading from '../atoms/Heading';
import AppointmentInfo from '../molecules/AppointmentInfo';
import Container, { Wrapper } from '../organisms/Container';
import Navigation from '../organisms/Navigation';

interface CancelAppointmentProps {
	getLabel: (key: string) => string;
}

export default function CancelAppointment({ getLabel }: CancelAppointmentProps) {
	const { appointment, locale, setScene, timezone } = useBookingContext();
	const [cancellationSuccess, setCancellationSuccess] = useState<boolean | null>(null);

	useEffect(() => {
		setScene('cancellation');
	}, []);

	if (!appointment.data) {
		return null;
	}

	const cancelAppointment = async () => {
		const success = await appointment.cancel();
		setCancellationSuccess(success);
	};

	const { startDatetime, endDatetime, manageBookingUrl } = appointment.data;
	const timeSlotString = formatFullDate(startDatetime, endDatetime, locale, timezone.current);

	if (cancellationSuccess === true) {
		return (
			<Container id="cancel-appointment">
				<Wrapper>
					<Heading title={getLabel('appointment_cancellation_success_heading')} />
					<AppointmentInfo heading={getLabel('appointment_info_preferred')} timeSlotString={timeSlotString} />
				</Wrapper>
				<Navigation keyProp="cancel-appointment" center={true}>
					<PrimaryButton onClick={appointment.clear} testId="new-appointment">
						{getLabel('booking_button_new_appointment')}
					</PrimaryButton>
				</Navigation>
			</Container>
		);
	} else if (cancellationSuccess === false) {
		return (
			<Container id="error">
				<Wrapper>
					<span className="error-icon"></span>
					<Heading title={getLabel('appointment_cancellation_failure_heading')} subtitle={getLabel('appointment_cancellation_failure_subline')} />
				</Wrapper>
				<Navigation keyProp="manage-appointment" center={true}>
					{manageBookingUrl ? (
						<PrimaryButton href={manageBookingUrl} testId="manage-appointment" blank={true}>
							{getLabel('booking_button_manage_appointment')}
						</PrimaryButton>
					) : (
						<PrimaryButton onClick={appointment.clear} testId="new-appointment">
							{getLabel('booking_button_new_appointment')}
						</PrimaryButton>
					)}
				</Navigation>
			</Container>
		);
	} else {
		return (
			<Container id="cancel-appointment">
				<Wrapper>
					<Heading title={getLabel('appointment_cancellation_heading')} subtitle={getLabel('appointment_cancellation_subline')} />
					<AppointmentInfo heading={getLabel('appointment_info_preferred')} timeSlotString={timeSlotString} />
				</Wrapper>
				<Navigation keyProp="cancel-appointment">
					<PrimaryButton onClick={cancelAppointment} testId="cancel-appointment" danger={true} hasLoader={true} loading={appointment.isCancelling}>
						{getLabel('booking_button_cancel_appointment')}
					</PrimaryButton>
					{!appointment.isCancelling && (
						<Button onClick={appointment.abortCancellation} testId="nav-back">
							{getLabel('nav_back_button')}
						</Button>
					)}
				</Navigation>
			</Container>
		);
	}
}
